module.exports = __webpack_public_path__ + "img/copyright-library.92e9c732.jpg";